// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tag_tip__AGmZs","icon":"Tag_icon__j9o0H","tagContent":"Tag_tagContent__54FvA","tagDescription":"Tag_tagDescription__FHN_M"};